import React from 'react';

import Input from 'Components/Input';
import Button from 'Components/Button/Button';

import useReducedErrors from 'Shared/hooks/useReducedErrors';

const PasswordResetView = ({
  formikProps: {
    handleChange,
    handleSubmit,
    handleBlur,
    errors,
    touched,
    values: { email },
  },
}) => {
  const reducedErrors = useReducedErrors(errors);

  return (
    <form onSubmit={handleSubmit}>
      <h2 className="form__heading">Password reset</h2>
      <p className="form__message">
        Enter your business email address below, and we'll email instructions for setting a new one.
      </p>
      <Input
        label="Business email"
        helper={(touched.email && reducedErrors.email) || ''}
        helperVariant={touched.email && reducedErrors.email ? 'error' : 'message'}
        fieldProps={{
          name: 'email',
          value: email,
          placeholder: 'Enter your business email',
          onChange: handleChange('email'),
          onBlur: handleBlur('email'),
        }}
      />
      <Button text="Reset password" type="submit" size="block" />
    </form>
  );
};

export default PasswordResetView;
